export enum EmbedSource {
  ZOHO_CRM = 'zoho-crm',
  ZOHO_CRM_WIDGET = 'zoho-crm-widget',
}
